// @flow
import * as React from "react";
import Media from "react-media";
import { rgba } from "polished";
import styled from "styled-components";
import { gaReducer } from "../GA";
import { fontSize } from "../common/styled-mixins";
import Gettext from "../common/Gettext";

import SocialItems from "./Items";
import SocialSidebar from "./Social";
import ToggleSocial, { SocialTradingContext } from "./ToggleSocial";

import ArrowIcon from "../Icons/ArrowRight";

const ArrowIconContainer = styled.div`
  margin-left: 16px;
  color: ${rgba("#919191", 0.59)};
`;

const HideSocial = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  align-content: flex-end;
  justify-content: flex-end;
  height: 50px;
  margin-left: auto;
  padding-right: 16px;
  font-size: ${fontSize(12)};
  white-space: nowrap;
  color: ${({ theme }) => theme.accent};
  cursor: pointer;
  text-decoration: underline;

  :hover {
    text-decoration: none;

    ${ArrowIconContainer} {
      color: ${({ theme }) => theme.foreground};
    }
  }
`;

const SidebarContainer = styled.div`
  position: absolute;
  top: 0;
  left: ${props => (props.isOpen ? "0" : "-256px")};
  opacity: ${props => (props.isOpen ? "1" : "0")};
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 256px;
  background-color: ${({ theme }) => theme.main};
  box-shadow: 3px 3px 5px 0px ${({ theme }) => rgba(theme.mainDark, 0.5)};
  z-index: 200;
  transition: .5s;

  @media (max-width: 959px) {
    position: fixed;
    height: auto;
    bottom: 0;
  }
`;

function SocialTrading() {
  const [isOpen, toggleOpen] = React.useContext(SocialTradingContext);

  return (
    <div>
      <Media
        query="(min-width: 960px)"
        render={() => (
          <SidebarContainer isOpen={isOpen}>
            <SocialSidebar
              hide={
                <HideSocial
                  onClick={() => {
                    gaReducer("CLOSE_SOCIAL_TRADING");
                    return toggleOpen(false);
                  }}
                >
                  <Gettext>Hide trader activity</Gettext>
                  <ArrowIconContainer>
                    <ArrowIcon />
                  </ArrowIconContainer>
                </HideSocial>
              }
            >
              <SocialItems />
            </SocialSidebar>
          </SidebarContainer>
        )}
      />
      <ToggleSocial
        onClick={() => {
          gaReducer(
            isOpen === true ? "CLOSE_SOCIAL_TRADING" : "OPEN_SOCIAL_TRADING"
          );
          return toggleOpen(!isOpen);
        }}
        isOpen={isOpen}
      />
    </div>
  );
}

export default SocialTrading;



// WEBPACK FOOTER //
// ./src/components/SocialTrading/Desktop.js